import React, { useEffect, useState } from 'react';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../../misc/constants';
import { getWindowVariable, reactToSmeDebug } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import GraphUI from './GraphUI';
import { SideMenuUIConfig } from './SideMenu';
var interval: any = null;
var update = false;
var animateAnimation = false;

const Sa02GraphUI = (props: UIProperties<Sa02GraphUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [percentage, setPercentage] = useState(100);
	const maxData: any = [
		110,
		107,
		105,
		103,
		100,
		97,
		93,
		86,
		74,
		58,
		38,
		17,
		8
	];

	const minData: any = [
		110,
		101,
		82,
		62,
		46,
		34,
		27,
		23,
		20,
		18,
		15,
		12,
		8
	];

	useEffect(() => {
		if(!interval && !props.parameters.isIdle) {
			var maxTimeInSeconds = props.parameters.apneaTimeInSeconds;
			var countDown = props.parameters.apneaTimeInSeconds;
			reactToSmeDebug('Sa02GraphUI', () => {
				var testInductionTime = getWindowVariable(constants.smeDebug.variables.apneaInductionTime);
				var testapneaTime = getWindowVariable(constants.smeDebug.variables.apneaApneaTime);
				
				props.parameters.inductionTimeInSeconds = testInductionTime;
				props.parameters.apneaTimeInSeconds = testapneaTime;
				maxTimeInSeconds = props.parameters.apneaTimeInSeconds;
				countDown = props.parameters.apneaTimeInSeconds;
				setPercentage(100);
			});
			
			interval = setInterval(() => {
				if(props.parameters.inductionTimeInSeconds >= 0) {
					props.parameters.inductionTimeInSeconds--;
					setPercentage(100);
				} else {
					countDown--;
					var percentage = (countDown / maxTimeInSeconds) * 100;
					if(percentage < 0) {
						percentage = 0;
					}
					setPercentage(percentage);
				}
				update = !update;
				setForceUpdate(update);
			}, 1000);
		}

		(window as any).sa02GraphRefresh = (sideMenuParams: SideMenuUIConfig) => {
			if (typeof (sideMenuParams.apneaTimeInSeconds) !== 'undefined') {
				animateAnimation = sideMenuParams.resetEtc02;
				if (animateAnimation) {
					// var percentage = 1 - (props.parameters.apneaTimeInSeconds / sideMenuParams.apneaTimeInSeconds);
					// var maxIncrease = percentage * sideMenuParams.apneaTimeInSeconds;
					// var totalCalls = 220 * 5;
					// var step = maxIncrease / totalCalls; 
					var step = 0.1;

					var currentVal = countDown;
					var int = setInterval(() => {
						currentVal += step;
						countDown = currentVal;
						countDown = Math.round(countDown);

						if (countDown >= props.parameters.apneaTimeInSeconds) {
							clearInterval(int);
							countDown = props.parameters.apneaTimeInSeconds;
							animateAnimation = false;
						}
						setPercentage((currentVal / sideMenuParams.apneaTimeInSeconds) * 100);
					}, 0)
				}
			}
		}
		
		return () => {
			if(interval) {
				clearInterval(interval);
				interval = null;
			}
		}
	}, []);

	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			left: '50px',
			top: '170px',
			width: '172px',
			height: '126px'
		}}>
			<GraphUI parameters={{
				width: 157,
				height: 126,
				color: 'purple',
				strokeWidth: 3,
				isDebug: false,
				maxData: maxData,
				minData: minData,
				interpolationPercentage: percentage
			}} id={Tools.generateGuid()} dispatch={props.dispatch} key={Tools.generateGuid()}></GraphUI>
		</div>
	);

};

export interface Sa02GraphUIConfig extends BaseConfig{
	inductionTimeInSeconds: number;
	apneaTimeInSeconds: number;
	isIdle: boolean;
}

export default Sa02GraphUI;